export enum CalibrationType {
  MULTI = 'multi',
  SIMPLE = 'simple',
}
